import React, { useEffect, useState } from "react";

import { useForm } from "../../../../../hooks/useForm";
import { useHistory } from "react-router-dom";

export const DesbloquearUsuarioPaso1 = () => {
    const history = useHistory();

    const [formValues, handleInputChange, reset] = useForm({
        documento: "",
    });
    const { documento } = formValues;
    const [errorDocument, seterrorDocument] = useState(null);
    const [isValid, setIsValid] = useState(false);

    let checkValues = () => {
        const regex = /^[0-9]*$/;
        const onlyNumbers = regex.test(documento);

        if (!onlyNumbers || documento.length < 8) {
            seterrorDocument("Debe tener solo números y ser mayor de 8 cifras");
        } else {
            seterrorDocument("");
        }

        if (onlyNumbers && documento.length >= 8) {
            setIsValid(true);
        } else {
            setIsValid(false);
        }
    };

    useEffect(() => {
        if (isValid) {
            handleSubmit();
        }
    }, [isValid]);

    let handleSubmit = (e) => {
        if (e) {
            e.preventDefault();
        }

        checkValues();

        // Validar que el tag Error codigo sea igual a 00 para dejarlo continuar. Sino mostrar mensaje de error
        // En Paso 2 si hay validaciones, aca faltan
        // http://sigaweb.com.ar/SIGAGX_TEST.Publicaciones/rest/webclientes/api/wsrecuperapassword?CUIT=20242851456&Token=041870DB10DD23887BAEB2779AE5A6BE

        if (isValid) {
            sessionStorage.setItem("ctLocal", btoa(documento));

            history.push("/desbloquear_usuario_ingresa_email");
        }
    };

    return (
        <div className="login">
            <div className="login_title">
                <h1>DESBLOQUEAR USUARIO</h1>
            </div>
            <div className="login_formDiv">
                <div className="login_formDiv--desktop">
                    <div className="login_formDiv--desktop--form">
                        <form className="login_form" onSubmit={handleSubmit}>
                            <h1>DESBLOQUEAR USUARIO</h1>
                            <p className="title mb-base">
                                Ingrese su CUIT / CUIL para desbloquear su usuario.
                            </p>

                            <input
                                className={`${
                                    errorDocument != null && errorDocument != ""
                                        ? "login_form--input errorInput"
                                        : "login_form--input"
                                } `}
                                placeholder="CUIT / CUIL"
                                name="documento"
                                value={documento}
                                onChange={handleInputChange}
                            />
                            <p
                                className={`${
                                    errorDocument != null && errorDocument != ""
                                        ? "errorMsgInput"
                                        : ""
                                } `}
                            >
                                {errorDocument}
                            </p>

                            <button
                                className="login_form--button mt-base"
                                type="submit"
                            >
                                Enviar
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
